import {
	faAddressBook,
	faAddressCard,
	faBars,
	faBasketShopping,
	faBook,
	faBoxArchive,
	faBoxesStacked,
	faBoxOpen,
	faBuilding,
	faBuildingColumns,
	faCalendarClock,
	faCalendarDays,
	faCalendarLines,
	faCalendarPen,
	faCalendarStar,
	faCalendarUsers,
	faCartShopping,
	faCartXmark,
	faCashRegister,
	faChartColumn,
	faCircleInfo,
	faCircleNodes,
	faCircleQuestion,
	faCommentDollar,
	faDatabase,
	faDesktop,
	faDoorOpen,
	faEnvelope,
	faFileChartColumn,
	faFileImport,
	faFileInvoiceDollar,
	faFileLines,
	faFilePen,
	faGaugeHigh,
	faGear,
	faGlobe,
	faHashtag,
	faIdCard,
	faLayerGroup,
	faList,
	faLocationDot,
	faMoneyBillTransfer,
	faMoneyBillTrendUp,
	faPager,
	faPalette,
	faPercent,
	faRepeat,
	faRobot,
	faSliders,
	faSlidersUp,
	faTableColumns,
	faTag,
	faTags,
	faTicket,
	faUserGear,
	faUsers,
	faUsersGear,
	faWifi,
	faWindowMaximize,
	faWindowMinimize
} from '@fortawesome/pro-regular-svg-icons';
import eventGroupType, { eventGroupTypeTranslate } from '@ameroservices-platform/shared/enums/eventGroupType';
import eventGroupState from '@ameroservices-platform/attraction-backend/app/main/apps/eventGroups/eventGroupState';

const navigationConfig = [
	{
		id: 'ameroAdmin',
		title: 'Amero Admin',
		type: 'group',
		icon: 'apps',
		auth: ['ameroadmin'],
		children: [
			{
				id: 'organisations',
				title: 'Organisationer',
				type: 'item',
				icon: faBuilding,
				url: '/apps/organisations',
				auth: ['ameroadmin'],
				exact: true
			},
			{
				id: 'invoice',
				title: 'Fakturering',
				type: 'item',
				icon: faFileInvoiceDollar,
				url: '/invoices',
				auth: ['ameroadmin'],
				exact: true
			}
		]
	},
	{
		id: 'user',
		title: '',
		type: 'group',
		icon: 'apps',
		requireOrganisation: true,
		children: [
			{
				id: 'dashboard',
				title: 'Dashboard',
				type: 'item',
				icon: faGaugeHigh,
				auth: ['dashboard.view'],
				url: '/apps/dashboard',
				exact: true
			},
			{
				id: 'tickets',
				title: 'Billetter',
				auth: ['tickets.view'],
				type: 'item',
				icon: faTicket,
				url: '/apps/tickets',
				exact: true
			},
			{
				id: 'subscriptions',
				title: 'Medlemskaber',
				auth: ['subscriptions.view'],
				type: 'item',
				icon: faIdCard,
				url: '/apps/subscriptions',
				exact: true,
				requireModule: 'subscriptions'
			},
			{
				id: 'customers',
				title: 'Kunder',
				auth: ['customers.view'],
				type: 'item',
				icon: faUsers,
				url: '/apps/customers',
				exact: true
			},
			{
				id: 'orders',
				title: 'Ordrer',
				auth: ['orders.view'],
				type: 'item',
				icon: faCartShopping,
				url: '/apps/orders',
				exact: true
			},
			{
				id: 'canceledOrders',
				title: 'Annullerede ordrer',
				auth: ['orders.view'],
				type: 'item',
				icon: faCartXmark,
				url: '/apps/canceled-orders',
				exact: true
			},
			{
				id: 'refunds',
				title: 'Refunderinger',
				auth: ['refunds.view'],
				type: 'item',
				icon: faMoneyBillTransfer,
				url: '/apps/refunds',
				exact: true
			},
			{
				id: 'manualEvents',
				title: 'Manuelle Begivenheder',
				auth: ['events.view'],
				type: 'collapse',
				icon: faCalendarPen,
				exact: true,
				children: [],
				requireModule: 'manualEvents'
			},
			{
				id: 'automaticEvents',
				title: 'Automatiske Begivenheder',
				auth: ['events.view'],
				type: 'collapse',
				icon: faRobot,
				exact: true,
				children: [],
				requireModule: 'automaticEvents'
			},
			{
				id: `events-${eventGroupType.EVENT_EVENTS}`,
				title: eventGroupTypeTranslate[eventGroupType.EVENT_EVENTS],
				auth: ['events.view'],
				type: 'collapse',
				icon: faCalendarStar,
				exact: true,
				children: [],
				requireModule: 'manualEvents'
			},
			{
				id: `events-${eventGroupType.EVENT_EVENTS}---${eventGroupState.HELD}`,
				title: `Arkiverede ${eventGroupTypeTranslate[eventGroupType.EVENT_EVENTS]}`,
				auth: ['events.view'],
				type: 'collapse',
				icon: faBoxArchive,
				exact: true,
				children: [],
				requireModule: 'manualEvents'
			},
			{
				id: `events-${eventGroupType.ENTRANCE_EVENTS}`,
				title: eventGroupTypeTranslate[eventGroupType.ENTRANCE_EVENTS],
				auth: ['events.view'],
				type: 'collapse',
				icon: faDoorOpen,
				exact: true,
				children: []
			},
			{
				id: `events-${eventGroupType.SUBSCRIPTION_EVENTS}`,
				title: eventGroupTypeTranslate[eventGroupType.SUBSCRIPTION_EVENTS],
				auth: ['events.view'],
				type: 'collapse',
				icon: faCalendarUsers,
				exact: true,
				children: [],
				requireModule: 'subscriptions'
			}
		]
	},
	{
		id: 'admin-diverse',
		title: '━',
		type: 'group',
		icon: 'apps',
		requireOrganisation: true,
		auth: [
			'statistics.statistics',
			'statistics.reports',
			'statistics.recurringScheduledJobs',
			'statistics.budgets',
			'statistics.import',
			'system.billing.view'
		],
		children: [
			{
				id: 'reports',
				title: 'Rapporter',
				type: 'item',
				icon: faFileChartColumn,
				url: '/apps/reports',
				auth: ['statistics.reports'],
				exact: true
			},
			{
				id: 'recurringScheduledJobs',
				title: 'Gentagende planlagte jobs',
				type: 'item',
				icon: faRepeat,
				url: '/apps/recurring-scheduled-jobs',
				auth: ['statistics.recurringScheduledJobs'],
				exact: true
			},
			{
				id: 'statistics',
				title: 'Statistik',
				type: 'item',
				icon: faChartColumn,
				url: '/apps/statistics',
				exact: true,
				auth: ['statistics.statistics'],
				requireModule: 'statistics'
			},
			{
				id: 'budget',
				title: 'Budgetter',
				type: 'item',
				icon: faMoneyBillTrendUp,
				url: '/apps/budgets',
				exact: true,
				auth: ['statistics.budgets'],
				requireModule: 'statistics'
			},
			{
				id: 'importJobs',
				title: 'Importér',
				type: 'item',
				icon: faFileImport,
				auth: ['statistics.import'],
				url: '/apps/import-jobs',
				exact: true
			},
			{
				id: 'billing',
				title: 'Fakturering',
				type: 'item',
				icon: faFileInvoiceDollar,
				auth: ['system.billing.view'],
				url: '/apps/billing',
				exact: true,
				noSalesChannel: true
			}
		]
	},
	{
		id: 'admin',
		title: 'Opsætninger',
		type: 'group',
		icon: 'apps',
		requireOrganisation: true,
		auth: [
			'setup.taxGroups',
			'setup.productGroups',
			'setup.products',
			'setup.followProducts',
			'setup.popups',
			'setup.discountCodeTypes.view',
			'setup.discountCodeTypes.edit',
			'setup.subscriptionTypes',
			'setup.eventGroups',
			'setup.eventGroupSchedulers',
			'setup.eventAttributeGroups',
			'setup.frontend.pageContent',
			'setup.frontend.theme',
			'setup.frontend.faq',
			'setup.frontend.navigations',
			'setup.frontend.header',
			'setup.frontend.footer',
			'setup.frontend.cartFields',
			'ameroadmin',
			'setup.flexpos.ticketSale',
			'setup.flexpos.members',
			'system.incrementalNumbers',
			'system.communicationTemplates',
			'system.locations',
			'system.countries',
			'system.financeDepartments',
			'system.user.management',
			'system.role.management'
		],
		children: [
			{
				id: 'productConfiguration',
				title: 'Produkt Opsætning',
				type: 'collapse',
				icon: faBoxesStacked,
				auth: [
					'setup.taxGroups',
					'setup.productGroups',
					'setup.products',
					'setup.followProducts',
					'setup.popups',
					'setup.discountCodeTypes.view',
					'setup.discountCodeTypes.edit'
				],
				children: [
					{
						id: 'taxGroups',
						title: 'Momskoder',
						type: 'item',
						icon: faPercent,
						url: '/apps/settings/vat',
						auth: ['setup.taxGroups'],
						exact: true,
						noSalesChannel: true
					},
					{
						id: 'ticketTypes',
						title: 'Produktgrupper',
						type: 'item',
						icon: faLayerGroup,
						url: '/apps/settings/product-groups',
						auth: ['setup.productGroups'],
						exact: true
					},
					{
						id: 'products',
						title: 'Produkter',
						type: 'collapse',
						icon: faBoxOpen,
						auth: ['setup.products'],
						exact: true,
						children: []
					},
					{
						id: 'followProducts',
						title: 'Følgeprodukter',
						type: 'item',
						icon: faTags,
						url: '/apps/follow-products',
						auth: ['setup.followProducts'],
						exact: true
					},
					{
						id: 'popups',
						title: 'Popups',
						type: 'item',
						icon: faCommentDollar,
						url: '/apps/popups',
						auth: ['setup.popups'],
						exact: true,
						requireModule: 'upsell'
					},
					{
						id: 'discountCodeTypes',
						title: 'Rabatkode-typer',
						type: 'item',
						icon: faTag,
						url: '/apps/settings/discount-code-types',
						auth: ['setup.discountCodeTypes.view', 'setup.discountCodeTypes.edit'],
						exact: true,
						requireModule: 'discountCodes'
					}
				]
			},
			{
				id: 'memberConfiguration',
				title: 'Medlems Opsætning',
				type: 'collapse',
				icon: faUsersGear,
				requireModule: 'subscriptions',
				auth: ['setup.subscriptionTypes'],
				children: [
					{
						id: 'subscriptionTypes',
						title: 'Medlemskabstyper',
						type: 'item',
						icon: faAddressCard,
						url: '/apps/settings/subscription-types',
						auth: ['setup.subscriptionTypes'],
						exact: true
					}
				]
			},
			{
				id: 'eventConfiguration',
				title: 'Begivenhedsopsætning',
				type: 'collapse',
				icon: faCalendarLines,
				requireModule: ['automaticEvents', 'manualEvents'],
				auth: ['setup.eventGroups', 'setup.eventGroupSchedulers', 'setup.eventAttributeGroups'],
				children: [
					{
						id: 'eventGroups',
						title: 'Grupper',
						type: 'item',
						icon: faCalendarDays,
						url: '/apps/settings/event-groups',
						auth: ['setup.eventGroups'],
						exact: true
					},
					{
						id: 'eventSchedulers',
						title: 'Planlægning',
						type: 'collapse',
						icon: faCalendarClock,
						requireModule: 'automaticEvents',
						auth: ['setup.eventGroupSchedulers'],
						exact: true
					},
					{
						id: 'eventAttributeGroups',
						title: 'Attribut Grupper',
						type: 'collapse',
						icon: faSlidersUp,
						exact: true,
						auth: ['setup.eventAttributeGroups'],
						children: []
					}
				]
			},
			{
				id: 'eventConfiguration-new',
				title: 'Begivenhedsopsætning',
				type: 'collapse',
				icon: faCalendarLines,
				requireModule: ['automaticEvents', 'manualEvents'],
				auth: ['setup.eventGroups'],
				children: [
					{
						id: `eventConfig-${eventGroupType.ENTRANCE_EVENTS}`,
						title: eventGroupTypeTranslate[eventGroupType.ENTRANCE_EVENTS],
						type: 'collapse',
						icon: faDoorOpen,
						exact: true,
						auth: ['setup.eventGroups'],
						children: [
							{
								id: `${eventGroupType.ENTRANCE_EVENTS}-eventGroups`,
								title: 'Grupper',
								type: 'item',
								icon: faCalendarDays,
								url: `/apps/settings/event-groups/${eventGroupType.ENTRANCE_EVENTS}`,
								auth: ['setup.eventGroups'],
								exact: true
							},
							{
								id: `${eventGroupType.ENTRANCE_EVENTS}-eventSchedulers`,
								title: 'Planlægning',
								type: 'collapse',
								icon: faCalendarClock,
								requireModule: 'automaticEvents',
								auth: ['setup.eventGroupSchedulers'],
								exact: true
							}
						]
					},
					{
						id: `eventConfig-${eventGroupType.EVENT_EVENTS}`,
						title: eventGroupTypeTranslate[eventGroupType.EVENT_EVENTS],
						type: 'collapse',
						icon: faCalendarStar,
						exact: true,
						auth: ['setup.eventGroups'],
						children: [
							{
								id: `${eventGroupType.EVENT_EVENTS}-eventGroups`,
								title: 'Grupper',
								type: 'item',
								icon: faCalendarDays,
								url: `/apps/settings/event-groups/${eventGroupType.EVENT_EVENTS}`,
								auth: ['setup.eventGroups'],
								exact: true
							},
							{
								id: `${eventGroupType.EVENT_EVENTS}-eventSchedulers`,
								title: 'Planlægning',
								type: 'collapse',
								icon: faCalendarClock,
								auth: ['setup.eventGroupSchedulers'],
								requireModule: 'automaticEvents',

								exact: true
							}
						],
						requireModule: 'manualEvents'
					},
					{
						id: `eventConfig-${eventGroupType.SUBSCRIPTION_EVENTS}`,
						title: eventGroupTypeTranslate[eventGroupType.SUBSCRIPTION_EVENTS],
						type: 'collapse',
						icon: faCalendarUsers,
						exact: true,
						auth: ['setup.eventGroups'],
						children: [
							{
								id: `${eventGroupType.SUBSCRIPTION_EVENTS}-eventGroups`,
								title: 'Grupper',
								type: 'item',
								icon: faCalendarDays,
								url: `/apps/settings/event-groups/${eventGroupType.SUBSCRIPTION_EVENTS}`,
								auth: ['setup.eventGroups'],
								exact: true
							},
							{
								id: `${eventGroupType.SUBSCRIPTION_EVENTS}-eventSchedulers`,
								title: 'Planlægning',
								type: 'collapse',
								icon: faCalendarClock,
								auth: ['setup.eventGroupSchedulers'],
								requireModule: 'automaticEvents',

								exact: true
							}
						],
						requireModule: 'subscriptions'
					},
					{
						id: 'eventAttributeGroups',
						title: 'Attribut Grupper',
						type: 'collapse',
						icon: faSlidersUp,
						exact: true,
						auth: ['setup.eventAttributeGroups'],
						children: []
					}
				]
			},
			{
				id: 'content',
				title: 'Frontend Opsætning',
				type: 'collapse',
				icon: faPager,
				auth: [
					'setup.frontend.pageContent',
					'setup.frontend.theme',
					'setup.frontend.faq',
					'setup.frontend.navigations',
					'setup.frontend.header',
					'setup.frontend.footer',
					'setup.frontend.cartFields',
					'setup.frontend.generalSettings'
				],
				children: [
					{
						id: 'generalSettings',
						title: 'Generelle indstillinger',
						type: 'item',
						icon: faSliders,
						url: '/apps/frontend-settings/general-settings',
						auth: ['setup.frontend.generalSettings'],
						exact: true
					},
					{
						id: 'pages',
						title: 'Sider',
						type: 'item',
						icon: faFileLines,
						url: '/apps/frontend-settings/pages',
						exact: true,
						auth: ['setup.frontend.pageContent']
					},
					{
						id: 'pageContents',
						title: 'Side indhold',
						type: 'collapse',
						auth: ['setup.frontend.pageContent'],
						icon: faFilePen
					},
					{
						id: 'faqs',
						title: 'FAQ',
						type: 'item',
						icon: faCircleQuestion,
						url: '/apps/frontend-settings/faqs',
						auth: ['setup.frontend.faq'],
						exact: true
					},
					{
						id: 'cart-settings',
						title: 'Kurvopsætning',
						type: 'item',
						icon: faBasketShopping,
						url: '/apps/frontend-settings/cart-settings',
						auth: ['setup.frontend.cartFields'],
						exact: true
					},
					{
						id: 'layout',
						title: 'Layout & design',
						type: 'collapse',
						icon: faTableColumns,
						auth: [
							'setup.frontend.footer',
							'setup.frontend.header',
							'setup.frontend.theme',
							'setup.frontend.navigations'
						],
						children: [
							{
								id: 'theme',
								title: 'Tema',
								type: 'item',
								icon: faPalette,
								url: '/apps/frontend-settings/theme',
								auth: ['setup.frontend.theme'],
								exact: true
							},
							{
								id: 'navigations',
								title: 'Navigationer',
								type: 'collapse',
								icon: faBars,
								auth: ['setup.frontend.navigations'],
								children: []
							},
							{
								id: 'header',
								title: 'Header',
								type: 'item',
								icon: faWindowMaximize,
								url: '/apps/frontend-settings/header',
								auth: ['setup.frontend.header'],
								exact: true
							},
							{
								id: 'footer',
								title: 'Footer',
								type: 'item',
								icon: faWindowMinimize,
								url: '/apps/frontend-settings/footer',
								auth: ['setup.frontend.footer'],
								exact: true
							}
						]
					},
					{
						id: 'informationForms',
						title: 'Ekstra informationsformularer',
						type: 'item',
						icon: faCircleInfo,
						url: '/apps/frontend-settings/information-forms',
						auth: ['setup.frontend.informationForms'],
						exact: true
					}
				]
			},
			{
				id: 'flexposSettings',
				title: 'FlexPOS Opsætning',
				type: 'collapse',
				icon: faDesktop,
				auth: ['setup.flexpos.ticketSale', 'setup.flexpos.members'],
				children: [
					{
						id: 'flexposSettings-ticketSale',
						title: 'Billetsalg',
						type: 'item',
						icon: faCashRegister,
						url: '/apps/flexpos-settings/ticket-sale',
						auth: ['setup.flexpos.ticketSale'],
						exact: true
					},
					{
						id: 'flexposSettings-members',
						title: 'Medlemsmodul',
						type: 'item',
						icon: faAddressBook,
						url: '/apps/flexpos-settings/members',
						exact: true,
						auth: ['setup.flexpos.members'],
						requireModule: 'subscriptions'
					}
				]
			},
			{
				id: 'systemConfiguration',
				title: 'System Opsætning',
				type: 'collapse',
				icon: faGear,
				auth: [
					'system.incrementalNumbers',
					'system.communicationTemplates',
					'system.locations',
					'system.countries',
					'system.financeDepartments',
					'system.user.management',
					'system.role.management'
				],
				children: [
					{
						id: 'incrementalNumbers',
						title: 'Fortløbende numre',
						type: 'item',
						icon: faHashtag,
						url: '/apps/settings/incremental-numbers',
						auth: ['system.incrementalNumbers'],
						exact: true,
						noSalesChannel: true
					},
					{
						id: 'mails',
						title: 'Kommunikationsskabeloner',
						type: 'item',
						icon: faEnvelope,
						url: '/apps/communication-templates',
						auth: ['system.communicationTemplates'],
						exact: true,
						noSalesChannel: false
					},
					{
						id: 'locations',
						title: 'Lokationer',
						type: 'item',
						icon: faLocationDot,
						url: '/apps/settings/locations',
						auth: ['system.locations'],
						exact: true
					},
					{
						id: 'lists',
						title: 'Lister',
						type: 'item',
						icon: faList,
						url: '/apps/settings/lists',
						auth: ['system.lists'],
						exact: true
					},
					{
						id: 'countries',
						title: 'Lande',
						type: 'item',
						icon: faGlobe,
						url: '/apps/settings/countries',
						auth: ['system.countries'],
						exact: true,
						noSalesChannel: true
					},
					{
						id: 'financeDepartments',
						title: 'Finansafdelinger',
						type: 'item',
						icon: faBuildingColumns,
						url: '/apps/finance-departments',
						exact: true,
						auth: ['system.financeDepartments'],
						requireModule: 'statistics'
					},
					{
						id: 'userManagement',
						title: 'Brugerstyring',
						type: 'item',
						icon: faUserGear,
						url: '/apps/settings/user-management',
						exact: true,
						auth: ['system.role.management', 'system.user.management'],
						noSalesChannel: true
					},
					{
						id: 'personalData',
						title: 'Personoplysninger',
						type: 'item',
						icon: faDatabase,
						url: '/apps/settings/personal-data',
						exact: true,
						auth: ['system.personal-data.settings', 'system.personal-data.anonymize'],
						noSalesChannel: true
					},
					{
						id: 'apiKeys',
						title: 'API',
						type: 'item',
						icon: faCircleNodes,
						url: '/apps/settings/api',
						exact: true,
						auth: ['system.api'],
						noSalesChannel: true
					}
				]
			}
		]
	},
	{
		id: 'links',
		title: 'Links',
		type: 'group',
		icon: 'apps',
		children: [
			{
				id: 'link-status',
				title: 'Status',
				type: 'item',
				icon: faWifi,
				url: '/status',
				exact: true
			},
			{
				id: 'link-docs',
				title: 'Hjælp og vejledninger',
				type: 'item',
				icon: faBook,
				url: '/docs',
				exact: true
			}
		]
	}
];

export default navigationConfig;
